import { DATABASE } from "../../types/tables-data";

export type ActionType = "added" | "updated" | "deleted";

export const getDatabaseEntityActionMessage = (
  entity: DATABASE,
  action: ActionType
): string => {
  const entityActionMessages: Record<DATABASE, Record<ActionType, string>> = {
    [DATABASE.LAWYERS]: {
      added: "Lawyer added successfully.",
      updated: "Lawyer updated successfully.",
      deleted: "Lawyer deleted successfully."
    },
    [DATABASE.CASES]: {
      added: "Case added successfully.",
      updated: "Case updated successfully.",
      deleted: "Case deleted successfully."
    },
    [DATABASE.FIRMS]: {
      added: "Firm added successfully.",
      updated: "Firm updated successfully.",
      deleted: "Firm deleted successfully."
    },
    [DATABASE.CLIENTS]: {
      added: "Case added successfully.",
      updated: "Client updated successfully.",
      deleted: "Client deleted successfully."
    },
    [DATABASE.DOCUMENTS]: {
      added: "Document added successfully.",
      updated: "Document updated successfully.",
      deleted: "Document deleted successfully."
    },
    // Add the rest of the entity messages following the same pattern...
    [DATABASE.FORMS]: {
      added: "Form added successfully.",
      updated: "Form updated successfully.",
      deleted: "Form deleted successfully."
    },
    [DATABASE.PROSPECTS]: {
      added: "Prospect added successfully.",
      updated: "Prospect updated successfully.",
      deleted: "Prospect deleted successfully."
    },
    [DATABASE.EXTRACTED]: {
      added: "Data extracted successfully.",
      updated: "Data extraction updated successfully.",
      deleted: "Data extraction deleted successfully."
    },
    [DATABASE.INDIVIDUALS]: {
      added: "Individual added successfully.",
      updated: "Individual updated successfully.",
      deleted: "Individual deleted successfully."
    },
    [DATABASE.DRAFTS]: {
      added: "Draft added successfully.",
      updated: "Draft updated successfully.",
      deleted: "Draft deleted successfully."
    },
    [DATABASE.QUESTIONNAIRES]: {
      added: "Questionnaire added successfully.",
      updated: "Questionnaire updated successfully.",
      deleted: "Questionnaire deleted successfully."
    },
    [DATABASE.BRIEF_REQUESTS]: {
      added: "Request added successfully.",
      updated: "Request updated successfully.",
      deleted: "Request deleted successfully."
    },
    [DATABASE.SIGNED_LETTERS]: {
      added: "Signed letter uploaded successfully.",
      updated: "Signed letter updated successfully.",
      deleted: "Signed letter deleted successfully."
    },
    [DATABASE.EVIDENCE_ARGUMENT]: {
      added: "Evidence arguments added successfully.",
      updated: "Evidence arguments updated successfully.",
      deleted: "Evidence arguments deleted successfully."
    },
    [DATABASE.ADMIN_UPDATES]: {
      added: "Update added successfully.",
      updated: "Update updated successfully.",
      deleted: "Update deleted successfully."
    },
    [DATABASE.CASE_RESEARCH]: {
      added: "Case research topic added successfully.",
      updated: "Case research topic updated successfully.",
      deleted: "Case research topic deleted successfully."
    },
    [DATABASE.CUSTOMERS]: {
      added: "Customer added successfully.",
      updated: "Customer updated successfully.",
      deleted: "Customer deleted successfully."
    },
    [DATABASE.EXHIBIT_LIST_FORMATS]: {
      added: "Exhibit list format added successfully.",
      updated: "Exhibit list format updated successfully.",
      deleted: "Exhibit list format deleted successfully."
    },
    [DATABASE.RFE_EXTRACTIONS]: {
      added: "Customer added successfully.",
      updated: "Customer updated successfully.",
      deleted: "Customer deleted successfully."
    },
    [DATABASE.DRAFT]: {
      added: "Draft added successfully.",
      updated: "Draft updated successfully.",
      deleted: "Draft deleted successfully."
    }
  };

  return entityActionMessages[entity][action];
};

// Example usage (removed logging)
